// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3MIPc","container":"styles_container__m64Rm","apiHealth":"styles_apiHealth__3Gjng","appVersion":"styles_appVersion__3aNva"};